import { API_BASE_URL } from '../services/api';

// Create apiClient for chat API
const apiClient = {
  // Helper function to make API requests
  request: async (method, endpoint, data = null, options = {}) => {
    const url = `${API_BASE_URL}${endpoint}`;
    const token = localStorage.getItem('token');
    
    const config = {
      method,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
        ...options.headers
      },
      ...options
    };

    if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
      config.body = JSON.stringify(data);
    }

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Network error' }));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API ${method} ${endpoint} error:`, error);
      throw error;
    }
  }
};

const chatAPI = {
  // Get all chats for the current user
  getAllChats: async () => {
    try {
      const response = await apiClient.request('GET', '/api/chats');
      return response;
    } catch (error) {
      console.error('Error fetching chats:', error);
      throw error;
    }
  },

  // Get a single chat by ID
  getChatById: async (chatId) => {
    try {
      const response = await apiClient.request('GET', `/api/chats/${chatId}`);
      return response;
    } catch (error) {
      console.error(`Error fetching chat ${chatId}:`, error);
      throw error;
    }
  },

  // Create a new chat for a booking
  createBookingChat: async (bookingId) => {
    try {
      const response = await apiClient.request('POST', `/api/chats/booking/${bookingId}`);
      return response;
    } catch (error) {
      console.error(`Error creating chat for booking ${bookingId}:`, error);
      throw error;
    }
  },

  // Create a new chat for a subscription
  createSubscriptionChat: async (subscriptionId) => {
    try {
      const response = await apiClient.request('POST', `/api/chats/subscription/${subscriptionId}`);
      return response;
    } catch (error) {
      console.error(`Error creating chat for subscription ${subscriptionId}:`, error);
      throw error;
    }
  },

  // Send a message in a chat
  sendMessage: async (chatId, content) => {
    try {
      const response = await apiClient.request('POST', `/api/chats/${chatId}/messages`, { content });
      return response;
    } catch (error) {
      console.error(`Error sending message in chat ${chatId}:`, error);
      throw error;
    }
  },

  // Mark all messages in a chat as read
  markMessagesAsRead: async (chatId) => {
    try {
      const response = await apiClient.request('PUT', `/api/chats/${chatId}/read`);
      return response;
    } catch (error) {
      console.error(`Error marking messages as read in chat ${chatId}:`, error);
      throw error;
    }
  }
};

export default chatAPI; 